import { put, call, takeLatest } from "redux-saga/effects";
import { AUTOMATIC } from "../actions";
import generateAction from "../../utils/action-helpers";
import redirectToLogin from "../../utils/redirect-to-login";

import { fetchPrevalidated } from "../../api/prevalidated";

function* fetchPrevalidatedSaga(action) {
  try {
    const response = yield call(fetchPrevalidated, action.payload);
    yield put(generateAction(AUTOMATIC.FETCH_SUCCESS, response.data));
  } catch (err) {
    if (err && err.response && err.response.status === 401) {
      redirectToLogin();
    }
    yield put(generateAction(AUTOMATIC.FETCH_ERROR));
  }
}

export default function* automaticSaga() {
  yield takeLatest(AUTOMATIC.FETCH, fetchPrevalidatedSaga);
}
